import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 50,
			height: 50,
			rx: 14,
			fill: "#DFF1FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5 22C32.5 20.0109 31.7098 18.1032 30.3033 16.6967C28.8968 15.2902 26.9891 14.5 25 14.5C23.0109 14.5 21.1032 15.2902 19.6967 16.6967C18.2902 18.1032 17.5 20.0109 17.5 22C17.5 30.75 13.75 33.25 13.75 33.25H36.25C36.25 33.25 32.5 30.75 32.5 22Z",
			stroke: "#19243E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.1624 38.25C26.9426 38.6288 26.6272 38.9433 26.2477 39.1619C25.8682 39.3805 25.4379 39.4956 24.9999 39.4956C24.5619 39.4956 24.1316 39.3805 23.7521 39.1619C23.3726 38.9433 23.0572 38.6288 22.8374 38.25",
			stroke: "#19243E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotifications;
